import { Component, OnInit, Input } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { AirModel } from './models/air/air-model';
import { StepperService } from './stepper.service';
import { SeaModel } from './models/sea/sea-model';
import {TruckModel} from "./models/truck/truck-model";
import { Subscription } from 'rxjs';
import { onSelectHistory } from './components/search-history/search-history.component';

@Component({
  selector: 'x-rightpanel',
  templateUrl: './app.rightpanel.component.html',
})
export class AppRightpanelComponent implements OnInit {

  stickyPanel: HTMLElement;
  initialOffsetTop: number;
  isEmpty: true;
  historySubscription: Subscription = null; 

  @Input("model") model: any = null;
  @Input("modelType") modelType: string = null;
  @Input("displayOptions") displayOptions: any = {showInfo: true,showLocation: true,showCargo: true, isConfirmation : false, showOnlyComponent: false} ;

  constructor(public appMain: AppMainComponent, private stepService: StepperService) {



  }

  ngOnInit(): void {

        setTimeout(() => {

         const element = document.querySelector('.custom-accordion') as HTMLElement;

          if (element) {
            this.initialOffsetTop = element.offsetTop + element.offsetHeight + 90;

            if (this.stickyPanel) {
            this.stickyPanel.style.top = `${this.initialOffsetTop}px`;
            }

 
          } else {
            console.warn('Element bulunamadı.');
          }



    
      }, 1000);
      
      if (!this.historySubscription) {
          this.historySubscription = onSelectHistory.subscribe(r => {
              let dataObject: any; 
              if (typeof r === 'string') {
                  try {
                      
                      dataObject = JSON.parse(r);
                  } catch (e) {
                      
                      console.error("Hata: String geçerli bir JSON formatında değil.", e);
                      dataObject = {}; 
                  }
              } else if (typeof r === 'object' && r !== null) {
                  dataObject = r;
              } else {
              
                  console.warn("Uyarı: r değişkeni ne string ne de obje.", r);
                  dataObject = {};
              }

              if (typeof dataObject === 'object' && dataObject !== null) {  
                  this.model = dataObject as any; 
                  
                  this.model.readinessDate = new Date();
                  this.model.totalVolume = 0;
                  this.model.totalWeight = 0;              
              }
          });
      }
    
    this.stickyPanel = document.querySelector('.sticky-panel');
    window.addEventListener('scroll', this.handleScroll.bind(this));

    switch (true) {
      case this.model instanceof AirModel:
          this.modelType = 'AIR';
          return;
      case this.model instanceof SeaModel:
          this.modelType = 'SEA';
          return;
        case this.model instanceof TruckModel:
            this.modelType = 'TRUCK';
            return;
    }

    if(this.model instanceof AirModel) this.modelType = 'AIR';
    if(this.model.operationType == 'LCL' || this.model.operationType == 'FCL' ) this.modelType = 'SEA';

    
  

  }


handleScroll() {
  if (this.stickyPanel) {
    if (window.pageYOffset > 300) {
      // Aşağılarda scroll yapıyorsak belli bir sabit değerde dursun
      this.stickyPanel.style.top = '105px';
    } else {
      // Sayfa yukarıdayken header’a tam yapışsın
      console.log(this.initialOffsetTop, "initialOfset")
      this.stickyPanel.style.top = `${this.initialOffsetTop}px`;
    }
  }
}
  formatPrice(price: number): string {
    return price.toLocaleString();
  }
}
